import { Model } from 'modules/core/lib/mobx-rest'

interface IPaymentItem {
  [key: string]: any
}

class PaymentItem extends Model<IPaymentItem> {
  static urlRoot() {
    return '/payroll/payment_items'
  }
}

export default PaymentItem
